;(function () {
  'use strict'

  var cache = Object.create(null)

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  function fetchArticles(term) {
    if (term in cache) return Promise.resolve(cache[term])
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    return fetch(
      root + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=article&resources[limit]=3'
    )
      .then(function (r) { return r.json() })
      .then(function (data) {
        var arts = (((data.resources || {}).results) || {}).articles || []
        cache[term] = arts
        return arts
      })
      .catch(function () {
        cache[term] = []
        return []
      })
  }

  function buildSection(articles) {
    var html = '<div class="results__group-3">' +
      '<div class="results results--blog-posts">' +
      '<h3 class="heading-sm predictive__label">Blog Posts</h3>' +
      '<ul role="listbox">'
    for (var i = 0; i < articles.length; i++) {
      var a = articles[i]
      var img = (a.image && a.image.url)
        ? '<div class="results-blog__image"><img src="' + a.image.url + '&width=60" alt="" width="60" height="60" loading="lazy"></div>'
        : ''
      html += '<li role="option"><a href="' + a.url + '">' +
        img + '<div class="results-blog__info"><span>' + escHtml(a.title) + '</span></div>' +
        '</a></li>'
    }
    return html + '</ul></div></div>'
  }

  function augment(container) {
    var ps = container.closest ? container.closest('predictive-search') : null
    var getInput = function () {
      return (ps && ps.querySelector('input[type="search"]')) ||
        document.querySelector('input[type="search"]')
    }

    new MutationObserver(function () {
      // Skip if already augmented or no real results yet
      if (container.querySelector('.results__group-3')) return
      if (!container.querySelector('.predictive-search-results')) return

      var input = getInput()
      var term = input ? input.value.trim() : ''
      if (!term) return

      var snapTerm = term
      fetchArticles(snapTerm).then(function (articles) {
        if (!articles.length) return
        // Bail if results were replaced while fetching
        if (container.querySelector('.results__group-3')) return
        var input2 = getInput()
        if (input2 && input2.value.trim() !== snapTerm) return

        var node = document.createElement('div')
        node.innerHTML = buildSection(articles)
        var footer = container.querySelector('.results__search-btn')
        if (footer) {
          container.insertBefore(node.firstElementChild, footer)
        } else {
          var wrap = container.querySelector('.predictive-search-results')
          if (wrap) wrap.appendChild(node.firstElementChild)
        }
      })
    }).observe(container, { childList: true })
  }

  function hookContainer(c) {
    if (c._blogAugmented) return
    c._blogAugmented = true
    augment(c)
  }

  function init() {
    document.querySelectorAll('#predictive-search, .search__results').forEach(hookContainer)

    // Catch containers added later (mobile drawer, etc.)
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return
          if (n.id === 'predictive-search' || (n.classList && n.classList.contains('search__results'))) {
            hookContainer(n)
          }
          n.querySelectorAll && n.querySelectorAll('#predictive-search, .search__results').forEach(hookContainer)
        })
      })
    }).observe(document.body, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
